<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Items</h3>
      </div>
    </div>
    <div style="max-height: 300px" class="table-responsive">
      <table>
        <thead>
          <tr>
            <th>Item</th>
            <th>Cod. Barra</th>
            <th>Cantidad</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td>
              {{ item.descripcion_item }}
            </td>
            <td>
              {{ item.codigo_barra }}
            </td>
            <td>
              {{ item.cantidad }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-buttons">
      <button @click="cerrar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cerrar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recaudacionId: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      items: [],
    };
  },
  methods: {
    cerrar: function () {
      this.$emit("cerrar");
    },
  },
  mounted: function () {
    axios
      .get(url + "/logistica/recaudaciones/" + this.recaudacionId + "/items")
      .then(({ data }) => {
        for (let i = 0; i < data.length; i++) {
          this.items.push({
            item_id: data[i].item_id,
            descripcion_item: data[i].item.descripcion,
            cantidad: data[i].cantidad,
            codigo_barra: data[i].codigo_barra,
          });
        }
      })
      .catch(() => {
        swal("Hubo un error, intente nuevamente.", "Error", "error");
      });
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/pedidos/ItemsConsultaRecaudaciones.vue